import { useMemo } from 'react';
import { StanFilterConfig } from '@/components/core-components/StanFilters/types';

export function useReferralsFilters(): StanFilterConfig[] {
    return useMemo(
        () => [
            {
                id: 'referral-username',
                label: 'User',
                type: 'text',
            },
            {
                id: 'referral-eid',
                label: 'Email',
                type: 'text',
            },
            {
                id: 'referral-date',
                label: 'Sign Up Date',
                type: 'date',
            },
        ],
        []
    );
}
